import { defineStore } from "pinia";

import axiosInst from "@/plugins/axios";
import moment from "moment";
import {
  BigAlert,
  connectionError,
  simpleError,
  notify,
} from "@/plugins/notify/notify";
import { useSessionStore } from "./sessionStore";
import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;
import openURL from 'quasar/src/utils/open-url.js';;
// import { useSessionStore } from "./sessionStore";

export const useBillStore = defineStore("billStore", {
  state: () => ({
    billData: {} as TypeBillData,

    userData: {
      fio: "",
      phone: "",
      email: "",
    } as TypeUserBillData,
    step: 1,
    checkData: {} as TypeCheckBillData,

    findLoading: false,
    waitPayment: false,

    paymentTypes: [] as TypeBillPayment[],
    lastPaymentTypeId: 0,

    redirectUrl: "",
  }),

  actions: {
    async getPaymentTypes() {
      await axiosInst()
        .post("/payment_type_bill", [{ division: window.onlDivision }])
        .then((res) => {
          const paymentTypesRes: { data: TypeBillPayment[]; result: string } =
            res.data;
          if (paymentTypesRes.result === "success") {
            this.paymentTypes = paymentTypesRes.data;
          } else {
            simpleError();
          }
        })
        .catch(async (e) => {
          console.error(e);

          if (e?.response?.status === 401) {
            await useSessionStore().createNewSession();
            await this.getPaymentTypes();
            return;
          }
          if (!e?.response?.status) {
            connectionError();
            return;
          }
          simpleError();
        });
    },

    async checkBill() {
      this.findLoading = true;

      useSessionStore().callBack("searchBill", "Поиск счета");

      // const data: TypeBillDataResult = (
      await axiosInst()
        .post("/check_ext_bill", [
          {
            docNum: this.billData.num,
            onl4PIN: this.billData.pin,
            paymentKey: this.billData.paymentType?.paymentKey,
          },
        ])
        .then((res) => {
          const data: TypeBillDataResult = res.data;

          switch (data.result) {
            case "success":
              this.checkData = {
                doc_date: moment(data.data.bill.doc_date).format("DD.MM.YYYY"),
                doc_num: data.data.bill.doc_num,
                Info: data.data.pmItem.Info,
                PayProc: data.data.pmItem.PayProc,
                PayKd: data.data.pmItem.PayKd,
                PaySum: data.data.pmItem.PaySum,
                TotalSum: data.data.pmItem.TotalSum,
                billID: data.data.bill.id,
              };
              this.step = 2;
              break;
            default:
              BigAlert({
                type: "warning",
                title: "Счет не найден!",
                message: "Проверьте правильность номера и кода.",
              });

              break;
          }
        })
        .finally(() => {
          this.findLoading = false;
        })
        .catch(async (e) => {
          console.error(e);

          if (e?.response?.status === 404) {
            BigAlert({
              type: "warning",
              title: "Счет не найден!",
              message: "Проверьте правильность номера и кода.",
            });
            return;
          }

          if (e?.response?.status === 401) {
            await useSessionStore().createNewSession();
            await this.checkBill();
            return;
          }
          if (!e?.response?.status) {
            connectionError();
            return;
          }
          simpleError();
        });
    },

    payBill(paymentMethod: TypePaymentMethod) {
      useSessionStore().callBack("searchBill", "Оплата счета");

      this.waitPayment = true;
      // проверка
      axiosInst()
        .post("/check_ext_bill", [
          {
            docNum: this.billData.num,
            onl4PIN: this.billData.pin,
            paymentKey: this.billData.paymentType?.paymentKey,
            billID: this.checkData.billID,
            customerFIO: this.userData.fio,
            email: this.userData.email,
            payAmount: this.checkData.PaySum,
            phone: this.userData.phone,
          },
        ])
        .then((data) => {
          const checkData = data.data;

          if (checkData?.result === "success") {
            // оплата
            this.payment(checkData.data.pmItem.Id, paymentMethod);
            return;
          }
          if (checkData?.result === "error") {
            BigAlert({
              type: "negative",
              message: checkData.resultMessage,
            });
            return;
          }
        })

        .catch(async (e) => {
          this.waitPayment = false;
          if (e?.response?.status === 401) {
            useSessionStore().timeoutError();
            return;
          }
          if (!e?.response?.status) {
            connectionError();
            return;
          }
          simpleError();
        });
    },

    async payment(paymentTypeId: number, paymentMethod: TypePaymentMethod) {
      await axiosInst()
        .post("/payment", [
          {
            URL: window.location.href,
            division: window.onlDivision,
            paymentTypeId: paymentTypeId,
            paymentMethod: paymentMethod,
          },
        ])
        .then((res) => {
          const paymentRes: TypePaymentRes = res.data;

          if (paymentRes?.result === "success") {
            // оплата картой
            if (paymentMethod == "card" && paymentRes?.redirectURL) {
              // открыть в новой вкладке
              const token = SessionStorage.getItem("token")?.toString();
              // window.open(paymentRes.redirectURL, "_blank");
              this.redirectUrl = paymentRes.redirectURL;
              openURL(paymentRes.redirectURL);

              if (token) this.checkPayment(token, paymentTypeId);
              return;
            }

            if (paymentMethod == "sbp" && paymentRes?.redirectURL) {
              // открыть в новой вкладке
              const token = SessionStorage.getItem("token")?.toString();
              // window.open(paymentRes.sbpURL, "_blank");
              this.redirectUrl = paymentRes.sbpURL;
              openURL(paymentRes.sbpURL);

              if (token) this.checkPayment(token, paymentTypeId);
              return;
            }

            if (paymentMethod == "deep" && paymentRes?.redirectURL) {
              // открыть в новой вкладке
              const token = SessionStorage.getItem("token")?.toString();

              if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
                  navigator.userAgent
                )
              ) {
                // window.open(paymentRes.deepLink, "_blank");
                this.redirectUrl = paymentRes.deepLink;
                openURL(paymentRes.deepLink);
              } else {
                if (paymentRes?.redirectURL) {
                  // window.open(paymentRes?.redirectURL, "_blank");
                  this.redirectUrl = paymentRes.redirectURL;
                  openURL(paymentRes?.redirectURL);
                }
              }

              this.lastPaymentTypeId = paymentTypeId;
              if (token) this.checkPayment(token, paymentTypeId);
              return;
            }
          }

          if (paymentRes?.result === "error") {
            notify({
              type: "negative",
              message: "Ошибка!",
              caption: paymentRes.resultMessage,
            });

            return;
          }
        })
        .catch(async (e) => {
          if (e?.response?.status === 401) {
            useSessionStore().timeoutError();
            return;
          }
          if (!e?.response?.status) {
            connectionError();
            return;
          }
          simpleError();
        });

      this.waitPayment = false;
    },

    async checkPayment(token: string, paymentTypeId: number) {
      axiosInst()
        .post(
          "/payment",
          [
            {
              division: window.onlDivision,
              paymentTypeId: paymentTypeId,
            },
          ],
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          const paymentRes: TypePaymentRes = res.data;
          switch (paymentRes.result) {
            case "success": {
              BigAlert({
                type: "positive",
                title: "Счет оплачен!",
                message: "Оплата прошла успешно.",
              });
              this.waitPayment = false;

              SessionStorage.remove("token");
              this.step = 1;
              break;
            }
            case "wait": {
              this.waitPayment = true;
              setTimeout(() => {
                if (this.waitPayment) this.checkPayment(token, paymentTypeId);
              }, 5000);
              break;
            }
            case "error": {
              notify({
                type: "negative",
                message: "Ошибка оплаты!",
                caption: "Повторите попытку.",
              });

              this.waitPayment = false;
              break;
            }

            default:
              {
                this.waitPayment = false;
              }
              break;
          }
        })
        .catch(async (e) => {
          if (!e?.response?.status) {
            connectionError();
            return;
          }
          simpleError();
        });
    },

    cancelPayment() {
      axiosInst()
        .post("/payment", [
          {
            division: window.onlDivision,
            paymentTypeId: this.lastPaymentTypeId,
            cancel: true,
          },
        ])
        .then((res) => {
          const cancelRes: TypePaymentRes = res.data;

          if (cancelRes.result == "success") {
            this.waitPayment = false;
          }

          if (cancelRes.result == "error") {
            notify({
              type: "negative",
              message: "Ошибка отмены оплаты!",
              caption: cancelRes.message,
            });
          }
        })

        .catch((e) => {
          if (!e?.response?.status) {
            connectionError();
            return;
          }
          simpleError();
        });
    },
  },
});

type TypePaymentRes = {
  result: "success" | "wait" | "error";
  message: string;
  resultMessage: string;
  redirectURL: string;
  sbpURL: string;
  deepLink: string;

  widget: boolean;
  widgetData: unknown;
};

interface TypeBillData {
  paymentType?: TypeBillPayment;
  num?: string;
  pin?: string;
}

interface TypeUserBillData {
  fio: string;
  phone: string;
  email: string;
}

interface TypeBillDataResult {
  data: {
    bill: {
      doc_date: string;
      doc_num: string;
      id: number;
    };
    pmItem: {
      Info: string;
      PayProc: number;
      PayKd: number;
      PaySum: number;
      TotalSum: number;
    };
  };
  result: string;
}

interface TypeCheckBillData {
  doc_date: string;
  doc_num: string;
  Info: string;
  PayProc: number;
  PayKd: number;
  PaySum: number;
  TotalSum: number;
  billID: number;
}

type TypeBillPayment = {
  // key: string;
  // description: string;

  Id: number;
  Description: string;
  PayType: string;
  Info: string;
  PayProc: number;
  PayKd: number;
  PaySum: number;
  TotalSum: number;

  allowCard: boolean;
  allowDeep: boolean;
  allowSPB: boolean;
  bank: TypeBanks;

  paymentKey: "8a0cba65-e87a-4141-a54c-a5a8250c0a51";
  selected?: boolean;
};

export type TypeBanks =
  | "SBRFE_TEST"
  | "SBRFE"
  | "SBRF_TEST"
  | "SBRF"
  | "ALFA_TEST"
  | "ALFA"
  | "CLOUD"
  | "GPB_TEST"
  | "GPB"
  | "RSHB_TEST"
  | "RSHB";

export type TypePaymentMethod = "card" | "deep" | "sbp";
